/*
 * This file is auto-generated. Do not modify it manually!
 */
import React from 'react';

import clsx from '@proton/utils/clsx';

import { MIME_ICON_VIEWBOX, type MimeIconComponentProps, getMimeIconAsset } from '../component';

export const MimeImage = ({ alt, title, size = 4, className, ...rest }: MimeIconComponentProps) => {
    const asset = getMimeIconAsset(size);

    return (
        <>
            <svg
                role="img"
                viewBox={MIME_ICON_VIEWBOX[asset]}
                focusable="false"
                className={clsx(`icon-size-${size}`, className)}
                {...rest}
            >
                {title ? <title>{title}</title> : null}
                {asset === 'sm' && (
                    <g>
                        <rect width="16" height="16" rx="2" fill="#DADBE0"></rect>
                        <path
                            d="M11.5569 10.6001C11.9181 10.6001 12.127 10.2135 11.9151 9.93741L9.43335 6.70366C9.32738 6.56558 9.10945 6.56558 9.00348 6.70366L7.1987 9.05531L6.19523 7.74779C6.08927 7.60971 5.87134 7.60971 5.76537 7.74779L4.08494 9.93741C3.87302 10.2135 4.08197 10.6001 4.44315 10.6001H11.5569Z"
                            fill="#3A3F4A"
                        ></path>
                        <path
                            d="M7.60001 5.8C7.60001 6.24183 7.24183 6.60001 6.8 6.60001C6.35817 6.60001 6 6.24183 6 5.8C6 5.35817 6.35817 5 6.8 5C7.24183 5 7.60001 5.35817 7.60001 5.8Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
                {asset === 'md' && (
                    <g>
                        <path
                            d="M0 2.5C0 1.11929 1.11929 0 2.5 0H21.5C22.8807 0 24 1.11929 24 2.5V21.5C24 22.8807 22.8807 24 21.5 24H2.5C1.11929 24 0 22.8807 0 21.5V2.5Z"
                            fill="#DADBE0"
                        ></path>
                        <path
                            d="M17.0616 15.9692C17.5756 15.9692 17.873 15.4191 17.5714 15.0261L14.0397 10.4242C13.8889 10.2277 13.5788 10.2277 13.428 10.4242L10.8596 13.7708L9.4316 11.9101C9.2808 11.7136 8.97068 11.7136 8.81988 11.9101L6.42849 15.0261C6.12691 15.4191 6.42427 15.9692 6.93826 15.9692H17.0616Z"
                            fill="#3A3F4A"
                        ></path>
                        <path
                            d="M11.4307 9.13847C11.4307 9.76723 10.921 10.2769 10.2923 10.2769C9.66352 10.2769 9.15381 9.76723 9.15381 9.13847C9.15381 8.50971 9.66352 8 10.2923 8C10.921 8 11.4307 8.50971 11.4307 9.13847Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
                {asset === 'lg' && (
                    <g>
                        <path
                            d="M3.39001 7.825C3.39001 4.03081 6.46582 0.955002 10.26 0.955002H27.9481C29.7183 0.955002 31.4202 1.63833 32.6989 2.86251L42.4909 12.2369C43.8445 13.5328 44.61 15.3254 44.61 17.1993V42.175C44.61 45.9692 41.5342 49.045 37.74 49.045H10.26C6.46582 49.045 3.39001 45.9692 3.39001 42.175V7.825Z"
                            fill="#DADBE0"
                        ></path>
                        <path
                            d="M44.4742 15.84H35.45C32.2881 15.84 29.725 13.2768 29.725 10.115V1.18877C30.8322 1.48526 31.8572 2.05672 32.6989 2.86251L42.4908 12.2369C43.5121 13.2146 44.1987 14.4751 44.4742 15.84Z"
                            fill="#EBECF0"
                        ></path>
                        <path
                            d="M44.61 17.5575H35.45C31.3396 17.5575 28.0075 14.2254 28.0075 10.115V0.955246C28.5922 0.960299 29.169 1.03985 29.725 1.18876V10.115C29.725 13.2768 32.2882 15.84 35.45 15.84H44.4742C44.5639 16.2841 44.61 16.7393 44.61 17.1993V17.5575Z"
                            fill="#BABBC5"
                        ></path>
                        <path
                            d="M34.6707 37.9009C35.7542 37.9009 36.3811 36.7412 35.7453 35.9128L28.3 26.2116C27.9821 25.7973 27.3284 25.7973 27.0105 26.2116L21.5961 33.2665L18.5857 29.3439C18.2678 28.9297 17.614 28.9297 17.2961 29.3439L12.2548 35.9128C11.619 36.7412 12.2459 37.9009 13.3295 37.9009H34.6707Z"
                            fill="#3A3F4A"
                        ></path>
                        <path
                            d="M22.8 23.5006C22.8 24.8261 21.7255 25.9006 20.4 25.9006C19.0745 25.9006 18 24.8261 18 23.5006C18 22.1751 19.0745 21.1006 20.4 21.1006C21.7255 21.1006 22.8 22.1751 22.8 23.5006Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
